<style src="./ContextSelectQuotes.scss" lang="scss"></style>
<template>
  <section class="context-select-quotes">
    <button
      type="button"
      @click="openModal"
      class="cp1-small-button cp1-button__warning">
      Escolher Cotações
    </button>

    <modal
      transition="nice-modal-fade"
      name="modalAutoSetQuote"
      width="500px"
      height="auto">
      <aside class="context-modal-confirm">
        <icon-danger class="illustration" />
        <span class="description">
          Essa ação irá escolher automaticamente todos os itens que tem 1 cotação disponível para escolha.
        </span>

        <form
          @submit.prevent="applyQuotation"
          class="form-modal">
          <button
            type="button"
            @click="cancelApply"
            class="btn-ghost">Cancelar ação</button>

          <button-submit
            label="Sim, escolha automaticamente"
            :state="commands.submitState"
            :icon-save="commands.saveIcon" />
        </form>
      </aside>
    </modal>
  </section>
</template>

<script>
import { ButtonSubmit } from '@/components/primitives'
import { IconRightArrow, IconDanger, IconSave } from '@/components/primitives/icons'
import MapToChoice from '../../helpers/MapToChoiceQuotation'
import FilterAvaliableQuotation from '../../helpers/FilterAvaliableQuotation'
import DefineLowestMaxPrice from '@/brain/item-pricing/define-lowest-max-price'

export default {
  name: 'ContextSelectQuotes',
  components: {
    ButtonSubmit,
    IconRightArrow,
    IconDanger,
    IconSave
  },
  data: () => ({
    addPercentual: 20,
    commands: {
      submitState: 'REPOSE',
      saveIcon: IconSave
    }
  }),
  methods: {
    cancelApply () {
      this.$modal.hide('modalAutoSetQuote')
    },
    openModal () {
      this.$modal.show('modalAutoSetQuote')
    },
    async applyQuotation () {
      this.commands.submitState = 'WAIT'

      const mapWithMargin = MapToChoice(this.$store.getters['ItemPricing/PROPOSAL_MARGIN'], this.$store.getters['ItemPricing/DECIMAL_PRECISION'])
      const filteredItems = []
      for (const item of this.$store.getters['ItemPricing/GET_ALL_LIST']) {
        const oneQuote = FilterAvaliableQuotation(item)
        if (oneQuote && oneQuote.length === 1) {
          filteredItems.push({
            ...item,
            quotation: oneQuote[0]
          })
        }
      }

      const payload = filteredItems.map(mapWithMargin)

      for (const item of filteredItems) {
        const quoteItem = item.quotation
        const proposalPrice = (quoteItem.price * ((this.$store.getters['ItemPricing/PROPOSAL_MARGIN'] / 100) + 1)).toFixed(this.$store.getters['ItemPricing/DECIMAL_PRECISION'])
        const proposalTotalPrice = proposalPrice * item.itemInfo.quantity * item.itemInfo.factor
        const proposalPerc = (((proposalPrice * 100) / quoteItem.price) - 100).toFixed()

        // Get the lowest value between Cmed and estimated as long as it's not zero
        const lowerValue = DefineLowestMaxPrice(quoteItem.cmedPrice, item.itemInfo.estimatedPrice)

        // Check if proposal is higher than max price
        const isHigherThanMax = proposalPrice > lowerValue
        const info = {
          quoted: {
            cmedLab: quoteItem.cmedLab,
            cmedPrice: quoteItem.cmedPrice,
            cmedTotalPrice: quoteItem.cmedPrice * item.itemInfo.quantity * item.itemInfo.factor,
            cmedPerc: (((quoteItem.cmedPrice * 100) / quoteItem.price) - 100).toFixed(),
            isPriceGuaranted: quoteItem.isPriceGuaranted,
            isQuoted: true,
            itemId: quoteItem.itemId,
            lab: quoteItem.lab,
            price: quoteItem.price,
            priceTotal: quoteItem.price * item.itemInfo.quantity * item.itemInfo.factor,
            proposalPrice,
            proposalTotalPrice,
            proposalPerc,
            minimumPrice: proposalPrice,
            minimumTotalPrice: proposalTotalPrice,
            minimumPerc: proposalPerc,
            proposalIsHigherThanMaxprice: isHigherThanMax,
            minimumIsHigherThanMaxprice: isHigherThanMax
          }
        }
        this.$store.commit('ItemPricing/SET_ITEM', {
          itemId: item.itemId,
          info
        })
      }

      try {
        await this.$store.dispatch('ItemPricing/AUTO_SET_ASSOCIATED', { payload })
        this.$toasted.success('Atualização salva com sucesso!')
      } catch (error) {
        this.$toasted.error(error)
      } finally {
        this.commands.submitState = 'REPOSE'
        this.$modal.hide('modalAutoSetQuote')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/item-pricing/components/context-select-quotes/ContextSelectQuotes.vue